/**
 * @fileoverview A página do assistente que cria o agente de IA (etapa 5 dos
 * planos), aberta pelo checklist do Dashboard. No fim (ativada ou não), volta
 * para a tela inicial.
 */

import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import AiSetupAssistant from "../../components/AiSetupAssistant";

const useStyles = makeStyles((theme) => ({
  page: {
    flex: 1,
    overflowY: "auto",
    padding: "40px 48px 56px",
    background: theme.palette.type === "dark" ? "#0A0A0A" : "#FFFFFF",
    // No celular, a barra de baixo fica por cima: o fim da página passa dela.
    [theme.breakpoints.down("sm")]: { padding: "24px 16px 112px" },
  },
  inner: { maxWidth: 1040, margin: "0 auto" },
}));

const AiSetup = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <div className={classes.page}>
      <div className={classes.inner}>
        <AiSetupAssistant onFinish={() => history.push("/")} onSkip={() => history.push("/")} />
      </div>
    </div>
  );
};

export default AiSetup;
